module.exports = __webpack_public_path__ + "50bf0b53.png";